export default "__VITE_ASSET__KuAyfv7Z__"